module.exports = __webpack_public_path__ + "media/images/bet__wrongMarker@2x-e882a12cf8f33bb164a2162b561fcbf1.png";